/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

angular.module('aviApp').directive('seSubheader', function() {
    return {
        restrict: 'E',
        templateUrl: 'src/views/infrastructure/serviceengine-subheader.html',
    };
});
